import { Group } from "three";
/**
 * Group that contains all tools.
 */
export class Tools extends Group {
    constructor() {
        super();
        this.lines = [];
        this.goniometers = [];
        this.name = "Tools";
    }
}
//# sourceMappingURL=Tools.js.map